import { render, staticRenderFns } from "./logintip.vue?vue&type=template&id=0968c7ca&scoped=true"
import script from "./logintip.vue?vue&type=script&lang=js"
export * from "./logintip.vue?vue&type=script&lang=js"
import style0 from "./logintip.vue?vue&type=style&index=0&id=0968c7ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968c7ca",
  null
  
)

export default component.exports